module.exports = __webpack_public_path__ + "static/item-7-1dbdf1accd814a5da61dd1d9d21dd965.png";